import { render, staticRenderFns } from "./SingleNoteDialog.vue?vue&type=template&id=45514fe1"
import script from "./SingleNoteDialog.ts?vue&type=script&lang=ts&external"
export * from "./SingleNoteDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./SingleNoteDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports